<span
  class="has-tooltip-left has-tooltip-multiline"
  [attr.data-tooltip]="tooltip | stripHtml"
  *ngIf="tooltip"
>
  <i class="icon {{ icon }} is-size-5"></i>
</span>
